import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { CompetenceTypeDataService } from "../../core/competencetypes.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-competencetype",
    template: require('./competencetype.edit.component.html')
})
export class EditCompetenceType extends EditBase<Nema.Crew.Model.CompetenceType> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject(CompetenceTypeDataService.Id) competenceTypeDataService: CompetenceTypeDataService,
        @Inject('competenceType') entity: Nema.Crew.Model.CompetenceType,
        @Inject("competenceGroups") public competenceGroups: Nema.Crew.Model.CompetenceGroup[],
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, competenceTypeDataService, $log, isNew);
    }

    public entityDisplayName = "Competence";

    public listStateName = "app.settings.competencetypes";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencetypes/competencetype.edit.component.ts